import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { usePermissionsStore } from "../permissions/permissions_store";
import Responses from "./responses";
import Viewer from "./SurveyResponseViewer";

// Completion links may be opened by message/guest readers without granting
// access to survey design, aggregate results or response management.
export default function SurveyResponseLink() {
  const { canView } = usePermissionsStore();
  const { surveyId } = useParams();
  const location = useLocation(), history = useHistory();
  const responseId = new URLSearchParams(location.search).get("response");
  if (canView("messaging.surveys")) return <Responses />;
  if (!/^[1-9]\d*$/.test(responseId || "")) return <p role="alert">A saved survey response link is required.</p>;
  return <Viewer selection={{ surveyId, responseId }} onClose={() => history.goBack()} />;
}
